module.exports = __webpack_public_path__ + "h5/img/child-navc3.0af7f402.png";